<div class="w-full flex flex-col items-center py-4">
    <div class="flex flex-col gap-5 w-full max-w-[632px] px-4">
        <!-- Back to overview button -->
        <button mat-button class="text-app-global-primary mr-auto" routerLink="/settings/models" i18n>
            <mat-icon svgIcon="arrow-left"></mat-icon>
            Terug naar overzicht
        </button>

        <!-- Page title -->
        <div class="flex items-center gap-4">
            <!-- Title -->
            <h1 *ngIf="aiModelId" class="text-[22px] font-semibold shrink-0" i18n>Model bewerken</h1>
            <h1 *ngIf="!aiModelId" class="text-[22px] font-semibold shrink-0" i18n>Model toevoegen</h1>

            <!-- Current model -->
            <p *ngIf="aiModel && breakpoint.sm.value"
                class="text-[22px] px-[8px] py-[10px] bg-app-global-quaternary text-app-global-quaternary-contrast rounded-[5px] whitespace-nowrap text-ellipsis overflow-hidden">
                {{aiModel.model}}
            </p>
        </div>

        <!-- General -->
        <p class="text-base font-semibold shrink-0 min-w-[120px]" i18n>Algemeen</p>
        <!-- Model name -->
        <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
            <p class="text-base shrink-0 min-w-[120px]" i18n>Model naam</p>
            <mat-form-field class="grow w-full sm:max-w-[420px]">
                <input matInput i18n-placeholder placeholder="Model naam"
                    [formControl]="aiModelFormGroup.controls.model">
                <mat-error i18n>Veld is verplicht</mat-error>
            </mat-form-field>
        </div>

        <!-- Provider -->
        <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
            <p class="text-base shrink-0 min-w-[120px]" i18n>Provider</p>
            <mat-form-field class="grow w-full sm:max-w-[420px]">
                <input matInput i18n-placeholder placeholder="Provider naam"
                    [formControl]="aiModelFormGroup.controls.provider">
                <mat-error i18n>Veld is verplicht</mat-error>
            </mat-form-field>
        </div>

        <!-- Type -->
        <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
            <p class="text-base shrink-0 min-w-[120px]" i18n>Type model</p>
            <mat-form-field class="grow w-full sm:max-w-[420px]">
                <mat-select placeholder="Selecteer een model type" [formControl]="aiModelFormGroup.controls.type"
                    class="no-label" i18n-placeholder>
                    <mat-option value="llm">Large Language Model</mat-option>
                    <mat-option value="embedding">Embedding model</mat-option>
                    <mat-option value="reranker">Reranker model</mat-option>
                </mat-select>
                <mat-error i18n>Veld is verplicht</mat-error>
            </mat-form-field>
        </div>

        <!-- URL -->
        <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
            <p class="text-base shrink-0 min-w-[120px]" i18n>URL</p>
            <mat-form-field class="grow w-full sm:max-w-[420px]">
                <input matInput i18n-placeholder placeholder="URL waar de API draait"
                    [formControl]="aiModelFormGroup.controls.url">
                <mat-error i18n>Invalide waarde</mat-error>
            </mat-form-field>
        </div>

        <!-- Technical -->
        <p class="text-base font-semibold shrink-0 min-w-[120px]" i18n>Technisch</p>

        <!-- API key -->
        <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
            <p class="text-base shrink-0 min-w-[120px]" i18n>API key</p>
            <mat-form-field class="grow w-full sm:max-w-[420px]">
                <input matInput i18n-placeholder placeholder="API key te gebruiken in de Authorization header"
                    [formControl]="aiModelFormGroup.controls.apiKey">
                <mat-error i18n>Veld is verplicht</mat-error>
            </mat-form-field>
        </div>

        <!-- Huggingface ID -->
        <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
            <p class="text-base shrink-0 min-w-[120px]" i18n>Huggingface ID</p>
            <mat-form-field class="grow w-full sm:max-w-[420px]">
                <input matInput i18n-placeholder placeholder="leon-se/gemma-3-27b-it-qat-W4A16-G128"
                    [formControl]="aiModelFormGroup.controls.huggingFaceId">
                <mat-error i18n>Invalide waarde</mat-error>
            </mat-form-field>
        </div>

        <!-- Context length -->
        <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
            <p class="text-base shrink-0 min-w-[120px]" i18n>Context length</p>
            <mat-form-field class="grow w-full sm:max-w-[420px]">
                <input matInput i18n-placeholder placeholder="Context length van model" type="number"
                    (wheel)="$event.preventDefault()" [formControl]="aiModelFormGroup.controls.contextLength">
                <mat-error i18n>Invalide waarde</mat-error>
            </mat-form-field>
        </div>

        <!-- Additional config -->
        <div class="w-full flex flex-col items-start justify-between gap-2">
            <p class="text-base font-semibold shrink-0 min-w-[120px]" i18n>Extra configuratie</p>
            <p class="text-base text-app-global-text-secondary" i18n>
                Extra JSON velden die worden meegestuurd met requests</p>
            <mat-form-field class="grow w-full">
                <textarea matInput i18n-placeholder placeholder="Vul valide JSON in" cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="7"
                    [formControl]="aiModelFormGroup.controls.additionalConfig"></textarea>
                <mat-error i18n>Invalide waarde</mat-error>
            </mat-form-field>
        </div>


        <!-- Delete / Cancel / Save -->
        <div class="flex justify-between gap-5 items-center">
            <button mat-button class="text-app-global-warning" i18n (click)="deleteAiModel(deleteDialog)"
                [ngClass]="{'invisible': !aiModelId || aiModel?.model_usage_count }">
                Model verwijderen
            </button>
            <div class="flex items-center gap-5">
                <button mat-button class="text-app-global-text-secondary" routerLink="/settings/models" i18n>
                    Annuleren
                </button>
                <button mat-flat-button color="primary" (click)="aiModel ? updateAiModel(updateDialog) : saveAiModel()"
                    i18n>
                    Opslaan
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Dialog to show when user wants to delete the model -->
<dynamic-dialog #deleteDialog>
    <h1 title i18n>Model verwijderen</h1>
    <p i18n class="text-center">
        Weet je zeker dat je dit model wilt verwijderen?
    </p>
</dynamic-dialog>

<!-- Dialog to show when user wants to update the model but it's in use by at least 1 organization -->
<dynamic-dialog #updateDialog>
    <h1 title i18n>Model aanpassen</h1>
    <p i18n class="text-center">
        Weet je zeker dat je dit model wilt aanpassen? Het wordt gebruikt door {{ this.aiModel?.model_usage_count }}
        organisaties!
    </p>
</dynamic-dialog>